export default __webpack_public_path__ + "static/media/physics.3a5d43db.png";